var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExclusive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.115.726s2.286 2.224 5.872 5.81h-.004c1.888 1.895 6.14 6.594 6.14 11.263 0 3.114-2.521 5.64-5.627 5.64a5.603 5.603 0 01-4.805-2.716.593.593 0 00-.443-.222c-.288 0-.555.205-.522.458.215 1.68 1.16 5.82 4.878 7.218H6.623c3.718-1.399 4.662-5.537 4.88-7.218.03-.253-.232-.458-.522-.458a.59.59 0 00-.443.22 5.614 5.614 0 01-4.807 2.717A5.633 5.633 0 01.104 17.8c0-4.671 4.252-9.368 6.142-11.262 3.58-3.587 5.87-5.811 5.87-5.811zm1.524 10.526l-1.523-4.705-1.524 4.705H5.65l3.996 2.909-1.524 4.705 3.994-2.909 3.995 2.909-1.528-4.705 3.996-2.909h-4.94z",
    fill: "#FCFCFC"
  })));
}
SvgIconExclusive.displayName = 'IconExclusive';
export default SvgIconExclusive;